import { css } from '@emotion/css';

export const createFeedbackModalStyles = css`
  max-height: min(76rem, calc(100vh - 15.6rem));
  min-height: min(76rem, calc(100vh - 15.6rem));
`;

export const buttonWidth = css`
  min-width: 11.6rem;
`;

export const sidebarWidth = css`
  width: 40.6rem;
`;
